import { useState } from "react";
import axios from "axios";
import "./auth.css";

// API base
const API_BASE_URL =
  import.meta.env.VITE_API_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://investor-backend-s4w5.onrender.com");

export default function AuthPage() {
  const [isLogin, setIsLogin] = useState(true);
  const [showInquiry, setShowInquiry] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [inquiryForm, setInquiryForm] = useState({
    name: "",
    mobile: "",
    email: "",
    amount: "",
  });

  const [loading, setLoading] = useState(false);
  const [inquiryLoading, setInquiryLoading] = useState(false);

  const handle = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleInquiryChange = (e) => {
    setInquiryForm({ ...inquiryForm, [e.target.name]: e.target.value });
  };

  const login = async () => {
    try {
      setLoading(true);

      const res = await axios.post(`${API_BASE_URL}/api/auth/login`, {
        email: form.email.trim().toLowerCase(),
        password: form.password,
      });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem(
        "user",
        JSON.stringify({
          _id: res.data.user._id,
          name: res.data.user.name,
          role: res.data.user.role,
        }),
      );

      alert("Login Success ✅");

      const role = res.data.user.role;

      if (role === "admin") {
        window.location.href = "/admin";
      } else if (role === "account") {
        window.location.href = "/account";
      } else {
        window.location.href = "/investor";
      }
    } catch (err) {
      console.log("Login error:", err);
      console.log("Response:", err?.response?.data);

      alert(
        err?.response?.data?.message ||
          `Login Failed ❌ (${err?.response?.status || "No response"})`,
      );
    } finally {
      setLoading(false);
    }
  };

  const signup = async () => {
    try {
      setLoading(true);

      await axios.post(`${API_BASE_URL}/api/auth/signup`, {
        name: form.name,
        email: form.email.trim().toLowerCase(),
        password: form.password,
      });

      alert("Signup Successful ✅");
      setIsLogin(true);
      setForm({
        name: "",
        email: "",
        password: "",
      });
    } catch (err) {
      console.log("Signup error:", err);
      alert(err?.response?.data?.message || "Signup Failed ❌");
    } finally {
      setLoading(false);
    }
  };

  const submitInquiry = async () => {
    if (
      !inquiryForm.name ||
      !inquiryForm.mobile ||
      !inquiryForm.email ||
      !inquiryForm.amount
    ) {
      alert("Please fill all inquiry details ❗");
      return;
    }

    try {
      setInquiryLoading(true);

      await axios.post(`${API_BASE_URL}/api/inquiry`, inquiryForm);

      alert("Inquiry sent successfully ✅");
      setInquiryForm({
        name: "",
        mobile: "",
        email: "",
        amount: "",
      });
      setShowInquiry(false);
    } catch (err) {
      console.log("Inquiry error:", err);
      alert(err?.response?.data?.message || "Error sending inquiry ❌");
    } finally {
      setInquiryLoading(false);
    }
  };

  return (
    <div className="split-auth-page">
      <div className="left-panel">
        <div className="poster-wrap">
          <img
            src="/poster.jpeg"
            alt="Magnira Opportunity to Lend"
            className="poster-image"
          />

          <button
            className="inquiry-open-btn"
            onClick={() => setShowInquiry(true)}
            type="button"
          >
            Inquiry
          </button>
        </div>

        {showInquiry && (
          <div className="inquiry-overlay">
            <div className="inquiry-modal">
              <button
                className="close-btn"
                onClick={() => setShowInquiry(false)}
                type="button"
              >
                ×
              </button>

              <h2>Inquiry Form</h2>

              <input
                name="name"
                placeholder="Full Name"
                value={inquiryForm.name}
                onChange={handleInquiryChange}
              />

              <input
                name="mobile"
                placeholder="Mobile Number"
                value={inquiryForm.mobile}
                onChange={handleInquiryChange}
              />

              <input
                name="email"
                placeholder="Email"
                value={inquiryForm.email}
                onChange={handleInquiryChange}
              />

              <input
                name="amount"
                placeholder="Approx Investment Amount"
                value={inquiryForm.amount}
                onChange={handleInquiryChange}
              />

              <button
                className="main-btn"
                onClick={submitInquiry}
                disabled={inquiryLoading}
                type="button"
              >
                {inquiryLoading ? "Sending..." : "Send Inquiry"}
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="right-panel">
        <div className="auth-box">
          <h2>{isLogin ? "Login Form" : "Signup Form"}</h2>

          <div className="toggle">
            <button
              className={isLogin ? "active" : ""}
              onClick={() => setIsLogin(true)}
              type="button"
            >
              Login
            </button>

            <button
              className={!isLogin ? "active" : ""}
              onClick={() => setIsLogin(false)}
              type="button"
            >
              Signup
            </button>
          </div>

          {!isLogin && (
            <input
              name="name"
              placeholder="Full Name"
              value={form.name}
              onChange={handle}
            />
          )}

          <input
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handle}
          />

          <input
            name="password"
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={handle}
          />

          {isLogin ? (
            <button
              onClick={login}
              className="main-btn"
              disabled={loading}
              type="button"
            >
              {loading ? "Please wait..." : "Login"}
            </button>
          ) : (
            <button
              onClick={signup}
              className="main-btn"
              disabled={loading}
              type="button"
            >
              {loading ? "Please wait..." : "Signup"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
